<template>
  <div class="mb-3">
    <label :for="id"
      >{{ label }} <span v-if="required" class="text-danger">*</span></label
    >
    <vee-field
      :name="name"
      :rules="validationRules"
      v-slot="{ field, handleChange, meta }"
    >
      <el-time-picker
        v-model="timeValue"
        :id="id"
        :placeholder="placeholder || 'Seleccione hora'"
        :format="format"
        @change="(val) => handleValueChange(val, handleChange)"
      />
    </vee-field>
    <ErrorMessage class="text-danger" :name="name" />
  </div>
</template>

<script setup>
import { ref } from "vue";

const timeValue = ref(null);

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  name: {
    type: String,
    required: true,
  },
  label: {
    type: String,
    required: true,
  },
  required: {
    type: Boolean,
    default: false,
  },
  placeholder: {
    type: String,
    default: "",
  },
  format: {
    type: String,
    default: "HH:mm:ss",
  },
  fieldName: {
    type: String,
    default: "",
  },
  validationRules: {
    type: [Function, Array, String, Object],
    default: () => () => true,
  },
});

function handleValueChange(val, handleChange) {
  timeValue.value = val;
  handleChange(val);
}
</script>
